import { useEffect } from 'react'
import { Outlet } from 'react-router'

import { RouteTracker } from 'trackers/google-analytics'
import { isTrackersEnabled } from 'trackers/helper'
import mixpanel from 'trackers/mixpanel'
import { useRouteSentryTransaction } from 'trackers/sentry'

// Reloading unconditionally on every vite:preloadError risks a reload loop if
// the asset is genuinely missing (bad deploy, blocked request) rather than
// stale. This session-scoped guard makes it reload once per stale-chunk
// incident instead of forever.
const PRELOAD_ERROR_RELOADED_KEY = 'yogi:preloadErrorReloaded'

export const RootLayout = (): JSX.Element => {
  useRouteSentryTransaction()

  useEffect(() => {
    const handler = (event: Event): void => {
      event.preventDefault()
      mixpanel.track('vite preload error')
      if (window.sessionStorage.getItem(PRELOAD_ERROR_RELOADED_KEY)) return
      window.sessionStorage.setItem(PRELOAD_ERROR_RELOADED_KEY, '1')
      window.location.reload()
    }
    window.addEventListener('vite:preloadError', handler)
    return () => window.removeEventListener('vite:preloadError', handler)
  }, [])

  return (
    <>
      {isTrackersEnabled() && <RouteTracker />}
      <Outlet />
    </>
  )
}
